import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * PadelCenterContext — hydrates current user's PC membership info on login.
 * Exposes: isMember, isAdmin, roleInPc, visibility, clubs, refresh().
 */
const PadelCenterContext = createContext({
  pc: { is_member: false, is_admin: false, role_in_pc: null, visibility: "both", clubs: [] },
  loading: false,
  refresh: async () => {},
});

export function PadelCenterProvider({ children }) {
  const { user } = useAuth();
  const [pc, setPc] = useState({ is_member: false, is_admin: false, role_in_pc: null, visibility: "both", clubs: [] });
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setPc({ is_member: false, is_admin: false, role_in_pc: null, visibility: "both", clubs: [] });
      return;
    }
    setLoading(true);
    try {
      const r = await api.get("/padel-center/info");
      setPc(r.data || {});
    } catch {
      setPc({ is_member: false, is_admin: false, role_in_pc: null, visibility: "both", clubs: [] });
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <PadelCenterContext.Provider value={{ pc, loading, refresh }}>
      {children}
    </PadelCenterContext.Provider>
  );
}

export function usePadelCenter() {
  return useContext(PadelCenterContext);
}
